export const TIME = {
    /**
     * @property ONE_HOUR_IN_SECONDS
     * @type {number}
     * @final
     */
    ONE_HOUR_IN_SECONDS: 3600
};
